<template>
 <div class="modal">
    <div class="modalBox">
        <div class="icon">
            <img :src="resolvedImgSrc" alt="">
        </div>
        <div class="content">
            {{ text }}
        </div>
        <div class="close" @click="closeModal">
            <img src="../assets/images/close.png" alt="">
        </div>
    </div>
</div>
</template>

<script>
//import {  } from ''
export default {
  name: 'componentName',
  props: {
    imgsrc:{
      type: String,
      default: () => require('../assets/images/success.png')
    },
    text:{
        default:'error'
    }
  },
  components: { },
  data () {
    return {

    }
  },
  computed: {
    resolvedImgSrc() {
      return typeof this.imgsrc === 'string' ? this.imgsrc : require('../assets/images/success.png');
    }
  },
  mounted() {

  },
  created() {

  },
  methods: {
    closeModal(){
        this.$emit('closeModal')
    }
  },
}

</script>
<style scoped lang='less'>

.modal {
  position: fixed;
  z-index: 9999;
  width: 100%;
  max-width: 500px;
  height: calc(100vh - 0px);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;


  .modalBox {
    position: absolute;
    width: 90%;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
    .icon {
      width: 60px;
      height: 60px;
      margin: -50px auto 0;
      img{
        width: 100%;
      }
    }
    .content{
      padding: 50px 20px;
      text-align: center;
      font-size: 18px;
    }
    .close{
      width: 50px;
      height: 50px;
      left: 50%;
      bottom: -60px;
      transform: translateX(-25px);
      position: absolute;
      img{
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/c-message.vue